import React from 'react'
import gql from 'graphql-tag'
import { v4 as uuidv4 } from 'uuid'
import { GraphQLFormProvider } from '@mymeerkat/react-form-helper'
import NewBeneficiary from './NewBeneficiary'
import { BuildLayout, Card, renderInput, renderDisplay, FormModal } from '../generic';
import { buildPercentageFields, percentageInitialValues, cleanExistingBeneficiaries, PercentageSummary } from './beneficiaryPercentages'
import { BENEFICIARIES } from './Beneficiaries'

const EditModal = (props) => {
  const { size } = props || 'small'
  return (
    <FormModal
      okText='Ok'
      cancelText='Back'
      width='100%'
      style={{ top: 10 }}
      disableCancel={true}
      disableOk={true}
      size={size}
      componentProps={props}
    />
  )
}

const buildFields = (existingBeneficiaries = []) => ({
  'beneficiaries[0].payToId': {
    type: 'select',
    options: [],
    label: 'Select a life covered to add as beneficiary',
    validate: (value) => {
      if (!value) {
        return 'This is required'
      }
    },
  },
  ...buildPercentageFields(existingBeneficiaries),
})

const config = {
  name: 'funeral',
  query: gql`
  query FuneralData($id: String!) {
    funeral(id: $id) {
      id
      livesCovered {
        id
        firstNames
        surname
        idNumber
        memberType
        cellNumbers
        email
        relationship
        }
        beneficiaries {
          id
          payToId
          payTo {
            id
            firstNames
            surname
            relationship
          }
          payoutType
          percentage

      }
    }
  }`,
  updateMutation: gql`
  mutation UpdateFuneral( $id: String!, $input: UpdateFuneralInput!) {
      updateFuneral(id: $id, input: $input) {
        id
        livesCovered {
        id
        firstNames
        surname
        idNumber
        memberType
        cellNumbers
        email
        relationship
        }
        beneficiaries {
          id
          payToId
          payTo {
            id
            firstNames
            surname
            relationship
          }
          payoutType
          percentage

      }
    }
  }`
}

function FormLayout(props) {
  const { id, afterSubmit, cancel, mode, data, formName, fields, existingBeneficiaries = [] } = props || {}
  const { funeral } = data || {}
  const { livesCovered } = funeral || {}
  const existingPayToIds = existingBeneficiaries.map(b => b.payToId)
  const options = []

  livesCovered && livesCovered.length > 0 && livesCovered
    .filter(m => m.memberType !== 'BENEFICIARY' && !existingPayToIds.includes(m.id))
    .forEach(member => options.push({
      value: member.id,
      label: `${member.firstNames} ${member.surname} - ${member.memberType}`,
      key: member.memberType,
    }))

  fields['beneficiaries[0].payToId'].options = options.sort((a, b) => (a.key < b.key) ? 1 : -1)

  const fieldNames = Object.keys(fields)

  return (
    <Card>
      <h3>Create a new beneficiary or select from the lives covered on the policy</h3>
      <EditModal Content={NewBeneficiary} heading='Create Beneficiary' text='Add New Person' {...props} mode={"add"} funeralId={id} memberType={'BENEFICIARY'} afterSubmit={afterSubmit} existingBeneficiaries={existingBeneficiaries} />
      <br />
      <br />
      <PercentageSummary existingBeneficiaries={existingBeneficiaries} />
      <BuildLayout formName={formName} fieldNames={fieldNames} mode={mode} fieldConfig={fields} direction='column' spacing={2} cancel={() => cancel()} />
    </Card>
  );
}

let Beneficiary = (props) => {
  const { id, cancel, afterSubmit, existingBeneficiaries = [] } = props
  const fields = buildFields(existingBeneficiaries)

  return (
    <div>
      <GraphQLFormProvider
        mode={"edit"}
        id={id}
        fields={fields}
        {...config}
        keepInitialValues
        initialValues={percentageInitialValues(existingBeneficiaries)}
        initialValuesFromData={(data) => ({
          ...(data && data.funeral) || {},
          ...percentageInitialValues(existingBeneficiaries),
        })}
        afterSubmit={(props) => { console.log('beneficiary afterSubmit', props); cancel() }}
        refetchQueries={[{ query: BENEFICIARIES, variables: { id } }]}
        renderDisplay={renderDisplay}
        renderInput={renderInput}
        InputFormLayout={(props) => <FormLayout {...props} formName={config.name} afterSubmit={afterSubmit} cancel={cancel} fields={fields} existingBeneficiaries={existingBeneficiaries} />}
        mapInputVariables={input => {
          const { beneficiaries: formBeneficiaries, existingPercentages = [] } = input
          const newEntry = formBeneficiaries.map(b => ({
            id: uuidv4(),
            payToId: b.payToId,
            percentage: Number(b.percentage),
          }))
          const cleanExisting = cleanExistingBeneficiaries(existingBeneficiaries, existingPercentages)
          return { input: { beneficiaries: [...cleanExisting, ...newEntry] } }
        }}
        DisplayFormLayout={FormLayout}
      />
    </div>
  )
}

export default Beneficiary
